import { SelectForColumnCell } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/select';

export default SelectForColumnCell;
